import { supabase } from './supabase'

/**
 * Get progress records for a care plan
 */
export const getCarePlanProgress = async (carePlanId, organizationId) => {
  try {
    const { data, error } = await supabase
      .from('care_plan_progress')
      .select('*, recorded_by_user:recorded_by(email, raw_user_meta_data)')
      .eq('care_plan_id', carePlanId)
      .eq('organization_id', organizationId)
      .order('progress_date', { ascending: false })

    if (error) throw error
    return data || []
  } catch (error) {
    console.error('Error fetching progress:', error)
    throw error
  }
}

/**
 * Create progress record
 */
export const createProgressRecord = async (progressData) => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    
    const { data, error } = await supabase
      .from('care_plan_progress')
      .insert({
        organization_id: progressData.organizationId,
        care_plan_id: progressData.carePlanId,
        client_id: progressData.clientId,
        progress_date: progressData.progressDate || new Date().toISOString(),
        progress_notes: progressData.notes || null,
        metrics: progressData.metrics || {},
        adherence_score: progressData.adherenceScore || null,
        recorded_by: user?.id,
      })
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error creating progress record:', error)
    throw error
  }
}

/**
 * Update progress record
 */
export const updateProgressRecord = async (progressId, updates) => {
  try {
    const { data, error } = await supabase
      .from('care_plan_progress')
      .update(updates)
      .eq('id', progressId)
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error updating progress record:', error)
    throw error
  }
}

/**
 * Get progress dashboard data
 */
export const getProgressDashboard = async (carePlanId, organizationId) => {
  try {
    const { data, error } = await supabase
      .from('care_plan_progress')
      .select('*')
      .eq('care_plan_id', carePlanId)
      .eq('organization_id', organizationId)
      .order('progress_date', { ascending: true })

    if (error) throw error

    // Calculate statistics
    const progressRecords = data || []
    const avgAdherence = progressRecords.length > 0
      ? progressRecords.reduce((sum, r) => sum + (r.adherence_score || 0), 0) / progressRecords.length
      : null

    return {
      records: progressRecords,
      totalRecords: progressRecords.length,
      averageAdherence: avgAdherence,
      latestRecord: progressRecords[0] || null,
    }
  } catch (error) {
    console.error('Error fetching progress dashboard:', error)
    throw error
  }
}

